/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PuntoDiRaccoltaDTO
 */
export interface PuntoDiRaccoltaDTO {
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    localita?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    cap?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    indirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    numeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    note?: string;
    /**
     * 
     * @type {number}
     * @memberof PuntoDiRaccoltaDTO
     */
    capienzaMassima?: number;
    /**
     * 
     * @type {number}
     * @memberof PuntoDiRaccoltaDTO
     */
    latitudine?: number;
    /**
     * 
     * @type {number}
     * @memberof PuntoDiRaccoltaDTO
     */
    longitudine?: number;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    informazioniDiAccesso?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaDTO
     */
    id?: string;
}

/**
 * Check if a given object implements the PuntoDiRaccoltaDTO interface.
 */
export function instanceOfPuntoDiRaccoltaDTO(value: object): value is PuntoDiRaccoltaDTO {
    return true;
}

export function PuntoDiRaccoltaDTOFromJSON(json: any): PuntoDiRaccoltaDTO {
    return PuntoDiRaccoltaDTOFromJSONTyped(json, false);
}

export function PuntoDiRaccoltaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PuntoDiRaccoltaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'numeroCivico': json['numeroCivico'] == null ? undefined : json['numeroCivico'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
        'capienzaMassima': json['capienzaMassima'] == null ? undefined : json['capienzaMassima'],
        'latitudine': json['latitudine'] == null ? undefined : json['latitudine'],
        'longitudine': json['longitudine'] == null ? undefined : json['longitudine'],
        'informazioniDiAccesso': json['informazioniDiAccesso'] == null ? undefined : json['informazioniDiAccesso'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function PuntoDiRaccoltaDTOToJSON(value?: PuntoDiRaccoltaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'nazioneId': value['nazioneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'localita': value['localita'],
        'cap': value['cap'],
        'indirizzo': value['indirizzo'],
        'numeroCivico': value['numeroCivico'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
        'capienzaMassima': value['capienzaMassima'],
        'latitudine': value['latitudine'],
        'longitudine': value['longitudine'],
        'informazioniDiAccesso': value['informazioniDiAccesso'],
        'id': value['id'],
    };
}

